import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { apiURL, EnvConfig } from "../../../../env-config";
import { HttpService } from "../../../../http.service";
import { DashboardHttpService } from "./dashboard-http.service";
import { TaskCommentService } from "../../tasks-page/tasks/task-comment/task-comment.service";
import { AuthService } from "../../../shared/services/auth.service";
import { UtilsService } from "../../../shared/services/utils.service";

@Injectable()
export class DashBoardService {

  constructor(
    private _http: HttpService,
    private _DashboardHttpService: DashboardHttpService,
    public _TaskCommentService: TaskCommentService,
    private _AuthService: AuthService,
    // private _WebSocketService: WebSocketService,
    private _UtilsService: UtilsService,
  ) { }

  getTaskStatusSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/tasks${queryParams}`);
  }

  getTaskRequestStatusSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/task-requests${queryParams}`);
  }

  getBillingDocumentSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/invoices${queryParams}`);
  }

  getQuotesSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/quotes${queryParams}`);
  }

  getSalesSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/sales${queryParams}`);
  }

  getTimeTrackSummary(startDate: string, endDate: string, company: any) {
    const queryParams = '?' + this._UtilsService.toQueryString({ startDate, endDate, company });
    return this._http.get(`${apiURL(EnvConfig.API_DASHBOARD)}/time-tracks${queryParams}`);
  }

}
